
import { BlogSection } from '@/types/blog';

export const introSection: BlogSection = {
  id: 'intro',
  title: 'Ein gesundes Verhältnis zu Geld entwickeln',
  content: `
    <p>
      Geld ist mehr als Zahlen auf dem Konto. Es ist mit Emotionen, Erfahrungen und tief verankerten Denkmustern verbunden. 
      Wer sein Verhältnis zu Geld bewusster gestaltet, trifft nicht nur bessere finanzielle Entscheidungen, sondern gewinnt 
      auch mehr innere Ruhe. Doch wie funktioniert das in der Praxis?
    </p>
    
    <p>
      Aktuelle finanzpsychologische und neurowissenschaftliche Untersuchungen zeigen: Unsere Geldentscheidungen sind oft 
      weniger rational, als wir denken. Doch mit den richtigen Strategien kannst du dein finanzielles Verhalten bewusst 
      steuern – und damit langfristig mehr finanzielle Unabhängigkeit erreichen.
    </p>
    
    <div class="my-8">
      <img 
        src="/images/blog/laptop-notizen.jpg" 
        alt="Laptop und Notizen auf einem Tisch - Finanzielle Klarheit schaffen" 
        class="rounded-lg w-full h-auto shadow-md" 
      />
      <p class="text-sm text-center mt-2 text-joerg-600">Finanzielle Klarheit beginnt mit Bewusstsein und strukturierter Planung</p>
    </div>
  `
};
